import Vue from 'vue';
import generateBootFunc from '../../generate-boot';
import Main from './Components/TemplateManager.vue';
import Index from './Components/TemplateManagerIndex.vue';

const bootTemplateManager = (id) => {
    new Vue({
        el: 'template-manager',
        render: (createElement) => {
            return createElement(Main, {
                props: id
            });
        }
    });
};

const bootTemplateManagerIndex = generateBootFunc(Index, 'template-manager-index');

export {
    bootTemplateManager,
    bootTemplateManagerIndex
};